<template>
  <div class="tianyi-gateway">
    <div v-show="isShow">
      <div id="fixedBg"></div>
      <p class="loading_p" id="loadP">
        <img src="/static/images/loadding.gif" />
      </p>
    </div>
  </div>
</template>

<style scoped src="../../assets/css/index.css"></style>
<style scoped src="../../assets/css/style.css"></style>

<script>
import { getInfoByCode } from '../../api/api'

// 走新页的产品
const NEW_UI_PRODUCT_NOS = ['hblsdtl', 'zhsgd']

export default {
  name: 'TianYiGateway',
  data() {
    return {
      isShow: true
    }
  },
  methods: {
    async routeByProduct() {
      const query = this.$route.query || {}
      const code = query.c
      if (!code) {
        this.isShow = false
        alert('缺少防伪码参数')
        return
      }
      try {
        const codeInfo = await getInfoByCode(code)
        const productNo = codeInfo && codeInfo.data && codeInfo.data.data
          ? codeInfo.data.data.productNo
          : ''
        const target = NEW_UI_PRODUCT_NOS.indexOf(productNo) !== -1
          ? '/tianyi/new'
          : '/tianyi/old'
        // 整页跳转，保证微信 JSSDK 入口 URL 与当前页一致（避免 router.replace 导致 invalid signature）
        // 带上 productNo，避免新页先渲染默认左图再切换造成闪一下
        const nextQuery = Object.assign({}, query, productNo ? { productNo } : {})
        const qs = Object.keys(nextQuery).map(k =>
          encodeURIComponent(k) + '=' + encodeURIComponent(nextQuery[k] == null ? '' : nextQuery[k])
        ).join('&')
        window.location.replace(target + (qs ? ('?' + qs) : ''))
      } catch (e) {
        this.isShow = false
        alert('防伪查询失败,请联系管理员')
      }
    }
  },
  created() {
    this.routeByProduct()
  }
}
</script>

<style scoped>
.tianyi-gateway {
  min-height: 100vh;
  background-color: rgb(18, 73, 39);
}
</style>



// WEBPACK FOOTER //
// src/components/TianYi/Gateway.vue